export const bindStickyFiltersClick = (targetElement: JQuery) => {
    targetElement.on('click', function () {
        const event = {
            type: 'Filters.OpenModal'
        } as JQuery.Event;
        wo$('body').trigger(event);
    });
};
